<template>
    <common-layout>
        <div class="PersonalInformation">
            <div class="header">
                <span class="txt">个人信息</span>
            </div>
            <div class="img_box">
                <el-image
                    style="width: 120px; height: 120px;border-radius:6px;overflow:hidden;"
                    :src="$store.getters.avatar||avatardefauter"
                    fit="scale-down"></el-image>
            </div>
            <ul>
                <li>
                    <span>姓名</span>
                    <span>{{$store.getters.name?$store.getters.name:'暂无'}}</span>
                </li>
                <li>
                    <span>性别</span>
                    <span>{{$store.getters.gender?$store.getters.gender==0?'男':'女':'暂无'}}</span>
                </li>
                <li>
                    <span>手机号</span>
                    <span>{{$store.getters.phone?$store.getters.phone:'暂无'}}</span>
                </li>
                <li>
                    <span>身份证号</span>
                    <span>{{$store.state.user.idCard?$store.state.user.idCard:'暂无'}}</span>
                </li>
                <li>
                    <span>身份证正反面</span>
                    <span>{{!$store.state.user.profile.idPicFront?'未上传':'已上传'}}</span>
                </li>
                <li>
                    <span>人脸识别</span>
                    <span>{{!$store.state.user.profile.facePic?'未上传':'已上传'}}</span>
                </li>
                <li>
                    <span>地址</span>
                    <span>{{$store.state.user.profile.address|address}}</span>
                </li>
            </ul>
            
        </div>
    </common-layout>
    
</template>
<script>
import CommonLayout from '@/components/LearningCenterComponents/Common'
export default {
    components:{
        CommonLayout
    },
    data(){
        return {
            avatardefauter:require('@/assets/images/avatardefauter.png'),
        }
    },
    filters:{
        address(data){
            const adderss = data?JSON.parse(data):null
            return adderss?`${adderss.provinceName}${adderss.cityName?'-'+adderss.cityName:''}${adderss.townName?'-'+adderss.townName:''}`:'暂未完善'
        }
    },
}
</script>
<style lang="scss" scoped>
.PersonalInformation{
    
    .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:30px;
        .txt{
            font-size: 20px;
            font-weight: bold;
            color: #3964E6;
        }
    }
    .img_box{
        padding: 0 70px;
    }
    ul{
        padding-bottom: 50px;
        li{
            font-size: 20px;
            padding: 29px 70px;
            border-bottom: 1px solid #EEEEEE;
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>